<div class="dynamic-input">
    <mat-form-field appearance="outline" *ngIf="isEditMode()" class="input-field">
      <mat-label>{{data.columnName}}</mat-label>
      <input matInput [placeholder]="data.columnName" [ngModel]="data.value" (keyup)="onInputType($event)">
      <mat-hint>{{inputHint}}</mat-hint>
    </mat-form-field>
    
    <mat-label *ngIf="data.value != null && !isEditMode()" style="font-size: 10px;">{{data.columnName}}</mat-label>
    <mat-chip-list *ngIf="!isEditMode()" class="chip-edit" >
      <mat-chip color="primary" selected (click)="switchEditingMode()" *ngIf="data.value != null"> 
        {{getShortValue(data.value)}}
      </mat-chip>
      <mat-chip (click)="switchEditingMode()" *ngIf="data.value == null">{{data.columnName}}</mat-chip>
    </mat-chip-list>
    
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="isEditMode()" (click)="switchEditingMode()"></i>
  </div>
